import axios, { AxiosResponse } from 'axios'
import { CatalogItem, Country, CountryListing, Order } from 'types/model'
import config from 'config'

interface CustomerRequest {
  firstName: string
  lastName: string
  email: string
  phone?: string
  address1?: string
  address2?: string
  city?: string
  state?: string
  postalCode?: string
  country?: string
}

interface PurchaseRequest {
  storefront: string
  currency: string
  campaign_id: string
  enableUpsells: boolean
  discountCode?: string
  items: { sku: string; stepNumber: number }[]
}

export interface AttributionRequest {
  utm_source?: string
  utm_medium?: string
  utm_campaign?: string
  utm_term?: string
  utm_content?: string
  click_id?: string
  aid?: string
  cid?: string
}

interface CreditCardRequest {
  cardNumber: string
  cardType: string
  expirationMonth: string
  expirationYear: string
  cvv: string
  postalCode: string
}

interface TokenRequest {
  referenceToken: string
}

interface ApplyDiscountRequest {
  discountCode: string
  items: [{ sku: string; quantity: number }]
}

export type SubmitCreditCardOrderRequest = CustomerRequest &
  CreditCardRequest &
  PurchaseRequest &
  AttributionRequest

export type SubmitReferenceOrderRequest = CustomerRequest &
  TokenRequest &
  PurchaseRequest &
  AttributionRequest

export type SubmitLeadRequest = CustomerRequest & AttributionRequest

interface SubmitOrderResponse {
  approved: boolean
  responseCode: string
  responseMessage: string
  errorMessage: string
  upsellToken?: string
  order: Order
}

const {
  pointOfSale: { apiUrl },
} = config

export async function post<TRes, TReq>(url: string, body: TReq) {
  return axios.post<TRes, AxiosResponse<TRes>, TReq>(apiUrl + url, body)
}

export const getCountries = async () => {
  const res = await axios.get<CountryListing>(apiUrl + `/pos/countries`)
  return res.data
}

export const getCountry = async (code: string) => {
  const res = await axios.get<Country>(apiUrl + `/pos/country/${code}`)
  return res.data
}

export async function getCatalogItem(sku: string, currency: string) {
  const res = await axios.get<CatalogItem>(
    apiUrl + `/pos/catalogItems/${sku}?currency=${currency}`
  )
  return res.data
}

export const submitLead = async (values: SubmitLeadRequest) => {
  return await post<any, SubmitLeadRequest>(`/pos/leads`, values)
}

export const submitOrder = async (values: SubmitCreditCardOrderRequest) => {
  return await post<SubmitOrderResponse, SubmitCreditCardOrderRequest>(
    `/pos/purchases`,
    values
  )
}

export const submitUpsell = async (values: SubmitReferenceOrderRequest) => {
  return await post<SubmitOrderResponse, SubmitReferenceOrderRequest>(
    `/pos/referenceOrders`,
    values
  )
}

export const applyDiscount = async (values: ApplyDiscountRequest) => {
  return await post<any, ApplyDiscountRequest>(`/pos/discounts`, values)
}
